import axios from 'axios';

export default async function RegisterAPI(data, onSuccess, onError){
    try{
        const response = await axios.post("/signup", data, {
            headers: {
                "Content-Type": "application/json"
            },
            withCredentials: true,
            // baseURL: "https://shielded-lowlands-66092.herokuapp.com/"
            baseURL: "https://salty-reaches-69347.herokuapp.com/"
        });
        console.log(response.data.status);
        onSuccess && onSuccess(response);
    }
    catch(error){
        console.log(error);
        onError && onError(error);
    }
}